/* eslint-disable no-unused-vars */
import {API_URL, API_URL_V2, currentPage, itemPerPage} from '../constants/index.js';
import {
    ISSUE,
    ISSUEV2,
    ISSUE_SUCCESS,
    ISSUE_ERROR,
    ADD_ISSUE,
    ADD_ISSUE_SUCCESS,
    ADD_ISSUE_ERROR,
    UPDATE_ISSUE,
    UPDATE_ISSUE_SUCCESS,
    UPDATE_ISSUE_ERROR,
    DELETE_ISSUE,
    DELETE_ISSUE_SUCCESS,
    DELETE_ISSUE_ERROR,
    ISSUE_ITEMS,
    ISSUE_ITEMS_SUCCESS,
    ISSUE_ITEMS_ERROR
} from '../constants/issueConstant.js';

import {sweetAlert} from '../components/Alert/sweetAlert'



//#region ISSUE (ALL - BYID)
export function getissue(data) {
    return {
        type: ISSUE,
        data
    }
}

export function getissuev2(data) {
    return {
        type: ISSUEV2,
        data
    }
}

export function getissueSuccess(data) {
    return {
        type: ISSUE_SUCCESS,
        data
    }
}

export function getissueError(data) {
    return {
        type: ISSUE_ERROR,
        data
    }
}

export function getAllIssues(currentPage) {
    return dispatch => {
        dispatch(getissue());
        fetch(API_URL_V2+`issues/issues?limit=${itemPerPage}&page=${currentPage}`,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+ localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(res => {
                //dispatch(getissueSuccess(res))
                if (currentPage === 0) 
                    dispatch(getissueSuccess(res));
                else
                    dispatch(getissuev2(res));
                    
                return res;
            })
            .catch(error => {
                dispatch(getissueError(error));
            })
    }
}

export function getIssuesByCommunity(communityId, sort) {
    return dispatch => {
        dispatch(getissue());
        fetch(API_URL+'issues/issuesByCommunityId/'+communityId,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+ localStorage.getItem('token'),
                    'sort': sort === true ? 1 : -1

                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getissueSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getissueError(error));
            })
    }
}

export function getissuesPerItems(data) {
    return {
        type: ISSUE_ITEMS,
        data
    }
}

export function getissueItemsSuccess(data) {
    return {
        type: ISSUE_ITEMS_SUCCESS,
        data
    }
}

export function getissueItemsError(data) {
    return {
        type: ISSUE_ITEMS_ERROR,
        data
    }
}

export function GetIssuesByItems(communityId, items) {
    return async(dispatch) => {
        dispatch(getissuesPerItems());
        
        const resp = await fetch(API_URL+'issues/issuesByItems/',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+ localStorage.getItem('token'),
                    'communityId':communityId,
                    'items':items.join(',')
                }
            })

        const body = await resp.json();

        if(resp.status===200){
            dispatch(getissueItemsSuccess(body));
            return body;
        }else{
            dispatch(getissueItemsError(body));

        }
    
    }
}

export function getIssueById(id) {
    return dispatch => {
        dispatch(getissue());
        fetch(API_URL+'issues/issues/' + id,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getissueSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getissueError(error));
            })
    }
}

//#endregion


//#region ADD ISSUE

    export function newissue(data) {
        return {
            type: ADD_ISSUE,
            data
        }
    }

    export function newissueSuccess(data) {
        
        return {
            type: ADD_ISSUE_SUCCESS,
            data
        }
    }

    export function newissueError(data) {

       
        return {
            type: ADD_ISSUE_ERROR,
            data
        }
    }

    export function addIssue(data) {
        return dispatch => {
            dispatch(newissue());
            fetch(API_URL+'issues/issues',
                {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json' ,
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                }
                })
                .then(res => res.json())
                .then(res => {
                    dispatch(newissueSuccess(res));
                    return res;
                })
                .then( () =>{
                    const message = `The issue ${data.name} has been added successfully`

                    sweetAlert('success',message,'alert_AddIssue_Success');
                })
                .catch(error => {
                    dispatch(newissueError(error));

                    const message = `An error occurred when trying to add the issue ${data.name} `

                    sweetAlert('error',message,'alert_AddIssue_Error');
                })
        }
    }

    export function addIssueByCommunity(data, communityId, objStyles) {
        return dispatch => {
            dispatch(newissue());
            fetch(API_URL+'issues/addissuebycommunityid/'+communityId,
                {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json' ,
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                }
                })
                .then(res => res.json())
                .then(res => {
                    dispatch(newissueSuccess(res));
                    return res;
                })
                .then( () =>{
                    const message = `The issue ${data.name} has been added successfully`

                    sweetAlert('success',message,'alert_AddIssueByCommunity_Success', objStyles);
                })
                .catch(error => {
                    dispatch(newissueError(error));

                    const message = `An error occurred when trying to add the issue ${data.name} `

                    sweetAlert('error',message,'alert_AddIssueByCommunity_Error', objStyles);
                })
        }
    }

//#endregion

//#region UPDATE ISSUE

    export function modIssue(data) {
        return {
            type: UPDATE_ISSUE,
            data
        }
    }

    export function modIssueSuccess(data) {
        return {
            type: UPDATE_ISSUE_SUCCESS,
            data
        }
    }

    export function modIssueError(data) {
        return {
            type: UPDATE_ISSUE_ERROR,
            data
        }
    }

    export function updIssue(id, data, objStyles) {
        return dispatch => {
            
            dispatch(modIssue());
            fetch(API_URL+'issues/issues/'+ id,
                {
                    method: 'PUT',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json' ,
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                }
                })
                .then(res => {
                    dispatch(modIssueSuccess(res));
                    return res;
                })
                .then( () =>{
                    const message = `The issue ${data.name} has been updated successfully`

                    sweetAlert('success',message,'alert_UpdateIssue_Success', objStyles);
                })
                .catch(error => {
                    dispatch(modIssueError(error));

                    
                    const message = `An error occurred trying to update the issue ${data.name} `

                    sweetAlert('error',message,'alert_UpdateIssue_Error', objStyles);

                })
        }
    }

//#endregion



//#region DELETE ISSUE

export function deleteIssue(data) {
    return {
        type: DELETE_ISSUE,
        data
    }
}

export function deleteIssueSuccess(data) {
  
    return {
        type: DELETE_ISSUE_SUCCESS,
        data
    }
}

export function deleteIssueError(data) {
    return {
        type: DELETE_ISSUE_ERROR,
        data
    }
}

export function delIssue(id, data) {
    return dispatch => {
        
        dispatch(deleteIssue());
        
        fetch(API_URL+'issues/issues/'+ id,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(deleteIssueSuccess(id));
                return res;
            })
            .then( () =>{
                const message = `The element has been deleted successfully`

                sweetAlert('success',message,'alert_DeleteIssue_Success');
            })
            .catch(error => {
                dispatch(deleteIssueError(error));

                const message = `An error occurred trying to update the issue `

                sweetAlert('error',message,'alert_DeleteIssue_Error');

            })
    }
}

export function delIssueByCommunity(id, objStyles) {
    return dispatch => {
        
        dispatch(deleteIssue());
        
        fetch(API_URL+'issues/delissuecommunity/'+ id,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(deleteIssueSuccess(id));
                return res;
            })
            .then( () =>{
                const message = `The element has been deleted successfully`

                sweetAlert('success',message,'alert_DeleteIssueByCommunity_Success', objStyles);
            })
            .catch(error => {
                dispatch(deleteIssueError(error));

                const message = `An error occurred trying to update the issue `

                sweetAlert('error',message,'alert_DeleteIssueByCommunity_Error', objStyles);

            })
    }
}
//#endregion
